import { render, staticRenderFns } from "./Spectors.vue?vue&type=template&id=02875b82&"
import script from "./Spectors.vue?vue&type=script&lang=js&"
export * from "./Spectors.vue?vue&type=script&lang=js&"
import style0 from "./Spectors.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports